import { render, staticRenderFns } from "./UpgradeOnboarding.vue?vue&type=template&id=7b533026&"
import script from "./UpgradeOnboarding.vue?vue&type=script&lang=js&"
export * from "./UpgradeOnboarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports